import React from "react";

function RescopeBtn({ onClick, style }) {
  return (
    <button type="button" className="btn btn-success" style={style} onClick={onClick}>
      <i className="fa fa-sliders"></i> Rescope
    </button>
  );
}

export default RescopeBtn;
